// Une fois que la page est chargée
window.addEventListener("DOMContentLoaded", () => {

  //Partial
  // Megamenu au survol
  $(".header__inline-menu details").hover(function (e) {
    $(this).attr("open", true);
    $(this).find(".header__submenu").mouseleave(function (e) {
      $(this).parent().removeAttr("open");
    });
  }, function (e) {
    $(this).attr("open", false);
  });

  // Footer mobile Accordéon
  $(function () {
    const breakpoint = 768;
    const openClass = 'is-open';
    const $titles = $('.footer__menu-columns .footer__menu-column-title');

    function enableMobileAccordion() {
      // Ferme tout au départ
      $titles.removeClass(openClass)
        .next('.footer__menu-column-list')
        .hide();

      $titles.off('click.mobile').on('click.mobile', function (e) {
        e.preventDefault();

        const $title = $(this);
        const $list = $title.next('.footer__menu-column-list');

        if ($title.hasClass(openClass)) {
          // Fermer celui cliqué
          $title.removeClass(openClass);
          $list.stop(true, true).slideUp(200);
        } else {
          // Fermer les autres
          $titles.not($title)
            .removeClass(openClass)
            .next('.footer__menu-column-list')
            .stop(true, true)
            .slideUp(200);

          // Ouvrir celui cliqué
          $title.addClass(openClass);
          $list.stop(true, true).slideDown(200);
        }
      });
    }

    function disableMobileAccordion() {
      // En desktop : tout visible, pas de clic
      $titles.off('click.mobile').removeClass(openClass);
      $titles.next('.footer__menu-column-list').show();
    }

    function checkViewport() {
      if ($(window).width() <= breakpoint) {
        enableMobileAccordion();
      } else {
        disableMobileAccordion();
      }
    }

    // Init + resize
    checkViewport();
    $(window).on('resize', checkViewport);
  });

  // Au clic sur #search-icon on ajoute la classe overflow-hidden-modal-opened à body
  $(document).on('click', '.header__icon', function () {
    $("body").toggleClass("overflow-hidden-modal-opened");
  });

  $(document).on('click', '.modal__close-button', function () {
    $("body").removeClass("overflow-hidden-modal-opened");
  });


  // PDP

  // Swiper produit media gallery pdp mobile
  if ($(".product_swiper").length && $(window).width() < 750) {
    var $swiperContainer = $(".product_swiper");
    var slideCount = $swiperContainer.find(".swiper-slide").length;

    if (slideCount === 1) {
      $swiperContainer.addClass("single-slide");
    }

    new Swiper(".product_swiper", {
      loop: slideCount > 1,
      pagination: {
        el: ".swiper-pagination",
        hide: false,
      },
    });
  }

  initURLTarget(); // Initialise les data-url_target cliquables

  // PLP
  // Quick add to card PLP
  $(document).on("click", "[data-card_product_variant_id]", function (e) {
    // prevent default action
    e.preventDefault();
    // prevent propagation
    e.stopPropagation();

    // si l'élément cliqué à une classe "disabled" on ne fait rien
    if ($(this).hasClass("disabled")) {
      return;
    }

    var $this = $(this);
    var variantId = $this.data("card_product_variant_id");
    var $form = $this.closest("product-form");
    var $input = $form.find('input[name="id"]');

    if ($input.length) {
      $input.val(variantId);
      $form.trigger("change");
    }
    $(this).closest('form').find('.quick-add__submit').click();
  });

  // Info produits
  // Info produits dans un tiroir
  $(document).on('click', '.accordeon_product_details .tabs.drawer_layout p[data-title]', function () {
    var selected_tab = $(this).data("title");
    $("body").addClass("overflow-hidden");
    $("#drawer_product_details.drawer").addClass("active");
    $("#drawer_product_details .product_accordeon > p[data-target='" + selected_tab + "']").addClass("active");
  });

  // Ouverture onglets détails produit dans le tiroir
  $(document).on('click', '.product_accordeon > p', function () {
    $("#drawer_product_details .product_accordeon > p").not(this).removeClass("active");
    $(this).toggleClass("active");
  });

  // Info produits dans un accordeon
  $(document).on('click', '.accordeon_product_details .tabs.accordeon_layout p[data-title]', function () {
    $(this).toggleClass("active");
    $(this).next("div").toggle();
  });

  // Ouverture drawer dispo boutique
  $(document).on('click', '.shop_availability', function () {
    $("body").addClass("overflow-hidden");
    $("#drawer_disponibilite.popin_shop_availability").addClass("active");
  });

  $(document).on('click', '.drawer_wrapper_inner', function (event) {
    event.stopPropagation();
  });

  // Ouverture onglets boutique
  $(document).on('click', '.boutique_header', function () {
    $(this).next("div").toggle();
  });

  // fermeture popin détails produit et dispo boutique
  $(document).on('click', '#drawer_product_details.drawer .icon-close, #drawer_product_details.drawer', function () {
    $("#drawer_product_details.drawer").removeClass("active");
    $("#drawer_product_details .product_accordeon > p").removeClass("active");
    setTimeout(() => {
      $("body").removeClass("overflow-hidden");
    }, 800);
  });

  $(document).on('click', '#drawer_disponibilite.drawer .drawer_close, #drawer_disponibilite.drawer', function () {
    $("#drawer_disponibilite.popin_shop_availability").removeClass("active");
    setTimeout(() => {
      $("body").removeClass("overflow-hidden");
    }, 800);
  });

  // Sticky CTA
  const add_to_cart_buttons = $('.product-form__buttons');
  const sticky_basket = $('#shopify-section-sticky_basket');


  $(document).scroll(function () {

    if ($(window).width() < 990) {
      if (add_to_cart_buttons.length === 0) {
        return;
      }

      const isVisible = isInViewport(add_to_cart_buttons);

      if (isVisible) {
        sticky_basket.slideUp(200);
      }
      else {
        sticky_basket.slideDown(200);
      }
    }
  });

  // Sticky button sur fiche produit
  $("#sticky_basket .scroll_to_button").click(function () {
    $([document.documentElement, document.body]).animate({
      scrollTop: $(".product__info-wrapper").offset().top
    }, 400);
  })

  $("#sticky_basket .add_to_cart").click(function () {
    $(".product-form__submit").click();
  })

  $("#sticky_basket .bis_trigger").click(function () {
    $(".klaviyo-bis-trigger").click();
  })

});

// Écoute des clics sur tous les éléments ayant l'attribut 'data-url_target'
function initURLTarget() {
  document.querySelectorAll("[data-url_target]").forEach(element => {
    element.addEventListener("click", () => {
      const url = element.dataset.url_target;
      if (url && url !== "#") {
        window.location.href = url;
      }
    });
  });
}

// Instagram swiper
class InstagramSwiper extends HTMLElement {
  constructor() {
    super();
    this.autoplay = this.dataset.autoplay === 'true';
    this.autoplayDelay = parseInt(this.dataset.autoplayDelay) || 3;
    this.slidesPerView = parseInt(this.dataset.slidesPerView) || 4;
    this.spaceBetween = parseInt(this.dataset.spaceBetween) || 24;
  }

  connectedCallback() {
    this.initializeSwiper();
  }

  initializeSwiper() {
    const swiperConfig = {
      slidesPerView: 'auto',
      spaceBetween: this.spaceBetween,
      loop: true,
      loopAdditionalSlides: 2,
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
        enabled: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 24,
        },
        480: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        750: {
          slidesPerView: this.slidesPerView,
          spaceBetween: this.spaceBetween,
        },
      },
    };

    // Ajouter l'autoplay si activé
    if (this.autoplay) {
      swiperConfig.autoplay = {
        delay: this.autoplayDelay * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    new Swiper(this.querySelector(".swiper"), swiperConfig);

    // Empêcher la propagation des clics sur les contrôles
    this.querySelectorAll(".swiper-button-next, .swiper-button-prev").forEach((element) => {
      element.addEventListener("click", (e) => {
        e.stopPropagation();
      });
    });
  }
}
customElements.define("instagram-swiper", InstagramSwiper);

// Boutique medias swiper
class BoutiqueMediasSwiper extends HTMLElement {
  constructor() {
    super();
    this.autoplay = this.dataset.autoplay === 'true';
    this.autoplayDelay = parseInt(this.dataset.autoplayDelay) || 3;
    this.slidesPerView = parseInt(this.dataset.slidesPerView) || 4;
    this.spaceBetween = parseInt(this.dataset.spaceBetween) || 24;
  }

  connectedCallback() {
    this.initializeSwiper();
  }

  initializeSwiper() {
    const swiperConfig = {
      slidesPerView: 'auto',
      spaceBetween: this.spaceBetween,
      loop: false,
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
        enabled: true,
      },
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        480: {
          slidesPerView: 1,
        },
        750: {
          slidesPerView: this.slidesPerView,
        },
      },
    };

    // Ajouter l'autoplay si activé
    if (this.autoplay) {
      swiperConfig.autoplay = {
        delay: this.autoplayDelay * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    new Swiper(this.querySelector(".swiper"), swiperConfig);

    // Empêcher la propagation des clics sur les contrôles
    this.querySelectorAll(".swiper-button-next, .swiper-button-prev").forEach((element) => {
      element.addEventListener("click", (e) => {
        e.stopPropagation();
      });
    });
  }
}
customElements.define("boutique-medias-swiper", BoutiqueMediasSwiper);


// Custom video player
class CustomVideoPlayer extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector("video");
    this.playButton = this.querySelector(".custom_video_play");
    this.pauseButton = this.querySelector(".custom_video_pause");
    this.controls = this.querySelector(".custom_controls");
  }

  connectedCallback() {
    this.addEventListener("click", this.handlePlayPause.bind(this));
  }

  handlePlayPause(event) {
    event.preventDefault();
    if (this.getAttribute("data-playing") === "true") {
      this.video.pause();
      this.setAttribute("data-playing", "false");
    } else {
      this.video.play();
      this.setAttribute("data-playing", "true");
    }
  }
}

customElements.define("custom-video-player", CustomVideoPlayer);

// Shipping
class ShippingDate extends HTMLElement {
  constructor() {
    super();
    this.onVariantChangeUnsubscriber = null;
  }

  connectedCallback() {
    this.shippingSpan = this.querySelector('.shipping_date');
    this.shippingDiffereSpan = this.querySelector('.shipping_date_differe');
    this.standardLine = this.shippingSpan?.closest('p');
    this.differeLine = this.shippingDiffereSpan?.closest('p');
    this.productInfo = this.closest('product-info');

    // Calcul initial
    this.refreshVisibilityAndDate();

    // Refresh à chaque changement de variante (robuste, même si le DOM ne remplace pas le bloc)
    if (typeof subscribe === 'function' && this.productInfo) {
      this.onVariantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        // Ne réagit que pour la même section produit
        if (data?.sectionId !== this.productInfo.sectionId) return;
        this.refreshVisibilityAndDate(data?.variant);
      });
    }
  }

  disconnectedCallback() {
    this.onVariantChangeUnsubscriber?.();
  }

  refreshVisibilityAndDate(variant = null) {
    // Si on reçoit la variante et qu'elle est indispo => cacher
    if (variant && !variant.available) {
      this.classList.add('hidden');
      return;
    }
    this.classList.remove('hidden');

    // Différé : dès la veille de la fenêtre, on bascule sur le message standard.
    // Décidé en JS car le rendu Liquid peut être servi depuis le cache Shopify ('now' périmé).
    const differeActif = !!this.differeLine
      && !ShippingDate.isDiffereExpired(parseInt(this.shippingDiffereSpan.dataset.dateStart, 10));
    this.differeLine?.classList.toggle('hidden', !differeActif);
    this.standardLine?.classList.toggle('hidden', differeActif);

    if (differeActif) this.formaterDateDifferee();
    else this.calculerLivraisonEstimee();
  }

  // Line item property `_date_differe` (snippets/differe-property.liquid) : active seulement si la
  // variante choisie a un différé encore affiché, pour que le checkout voie la même chose que le client.
  static syncDiffereProperty(form) {
    const input = form?.querySelector?.('input[data-differe-dates]');
    if (!input) return;
    let dates = {};
    try { dates = JSON.parse(input.dataset.differeDates); } catch (e) { /* JSON invalide : pas de propriété */ }
    const iso = dates[form.querySelector('input[name="id"]')?.value];
    const actif = !!iso && !ShippingDate.isDiffereExpired(Date.parse(`${iso}T12:00:00Z`) / 1000);
    input.disabled = !actif;
    input.value = actif ? iso : '';
  }

  // Vrai si l'on est à la veille (ou au-delà) du premier jour de la fenêtre différée.
  static isDiffereExpired(startSeconds, now = ShippingDate.inWarehouseTimeZone()) {
    if (isNaN(startSeconds)) return false;
    const veille = ShippingDate.inWarehouseTimeZone(new Date(startSeconds * 1000)).date;
    veille.setUTCDate(veille.getUTCDate() - 1);
    return now.date >= veille;
  }

  // Règles communes à tous les marchés. Seul le délai (jours ouvrés) varie, via le metafield
  // de marché custom.delai_jours_ouvres rendu dans window.ELX_SHIPPING (snippets/shipping-config.liquid).
  static RULES = {
    timeZone: 'Europe/Paris', // l'heure limite s'évalue à l'heure de l'entrepôt, pas du client
    cutoffHour: 12,           // commande avant midi => expédiée le jour même (jour ouvré)
    saturdayDelivery: true,   // le samedi compte comme jour de livraison, pas le dimanche
    defaultBusinessDays: 2,   // repli si le marché n'a pas de délai renseigné
  };

  // Date et heure d'un instant (maintenant par défaut) dans le fuseau de l'entrepôt.
  // La date est normalisée à midi UTC pour manipuler des jours calendaires sans effet DST.
  static inWarehouseTimeZone(instant = new Date()) {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: ShippingDate.RULES.timeZone,
      year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hour12: false,
    }).formatToParts(instant);
    const get = (type) => parseInt(parts.find((p) => p.type === type).value, 10);
    return {
      date: new Date(Date.UTC(get('year'), get('month') - 1, get('day'), 12)),
      hour: get('hour') % 24,
    };
  }

  // Calcule la date de livraison estimée : expédition le jour même si jour ouvré avant l'heure
  // limite, sinon le prochain jour ouvré ; puis N jours de livraison (lun-sam) après l'expédition.
  static computeDeliveryDate(businessDays, now = ShippingDate.inWarehouseTimeZone()) {
    const rules = ShippingDate.RULES;
    const isBusinessDay = (d) => d.getUTCDay() >= 1 && d.getUTCDay() <= 5;
    const isDeliveryDay = (d) => isBusinessDay(d) || (rules.saturdayDelivery && d.getUTCDay() === 6);
    const nextDay = (d) => d.setUTCDate(d.getUTCDate() + 1);

    const ship = new Date(now.date);
    if (!isBusinessDay(ship) || now.hour >= rules.cutoffHour) {
      do { nextDay(ship); } while (!isBusinessDay(ship));
    }

    const delivery = new Date(ship);
    let remaining = businessDays;
    while (remaining > 0) {
      nextDay(delivery);
      if (isDeliveryDay(delivery)) remaining--;
    }
    return delivery;
  }

  calculerLivraisonEstimee() {
    if (!this.shippingSpan) return;

    const configured = parseInt(window.ELX_SHIPPING?.businessDays, 10);
    const businessDays = configured > 0 ? configured : ShippingDate.RULES.defaultBusinessDays;

    const delivery = ShippingDate.computeDeliveryDate(businessDays);
    const locale = document.documentElement.lang || 'fr';
    this.shippingSpan.textContent = delivery.toLocaleDateString(locale, {
      year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC',
    });
  }

  formaterDateDifferee() {
    if (!this.shippingDiffereSpan) return;
    const startTs = parseInt(this.shippingDiffereSpan.dataset.dateStart) * 1000;
    const endTs = parseInt(this.shippingDiffereSpan.dataset.dateEnd) * 1000;
    if (isNaN(startTs) || isNaN(endTs)) return;

    // Formatage dans le fuseau de l'entrepôt, pas celui du visiteur : sinon un client à l'ouest
    // de Paris (UK, USA) voyait les dates reculer d'un jour.
    const formatter = new Intl.DateTimeFormat('fr-FR', {
      timeZone: ShippingDate.RULES.timeZone, day: '2-digit', month: '2-digit', year: 'numeric',
    });
    const fmt = (ts) => formatter.format(new Date(ts));
    const startStr = fmt(startTs);
    const endStr = fmt(endTs);

    const dates = [startStr, endStr];
    let i = 0;
    this.shippingDiffereSpan.textContent = this.shippingDiffereSpan.textContent
      .replace(/\d{2}\/\d{2}\/\d{4}/g, () => dates[i++]);
  }
}

customElements.define('shipping-date', ShippingDate);

// Synchro de `_date_differe` : au chargement et à chaque formulaire injecté (quick-add, swap de produit,
// upsell du tiroir… : le bouton de paiement express lit le formulaire tel quel, sans passer par le submit),
// à chaque changement de variante (product-info.js et les cards modifient l'input `id`), et juste avant
// chaque ajout au panier. Le submit est écouté en capture pour passer avant product-form.js.
const syncDifferePropertiesIn = (root) => root.querySelectorAll('input[data-differe-dates]')
  .forEach((input) => ShippingDate.syncDiffereProperty(input.form));
syncDifferePropertiesIn(document);
new MutationObserver((mutations) => mutations.forEach(({ addedNodes }) => addedNodes.forEach((node) => {
  if (node.nodeType === Node.ELEMENT_NODE) syncDifferePropertiesIn(node);
}))).observe(document.body, { childList: true, subtree: true });
document.addEventListener('change', (event) => {
  if (event.target.name === 'id') ShippingDate.syncDiffereProperty(event.target.form);
});
document.addEventListener('submit', (event) => ShippingDate.syncDiffereProperty(event.target), true);

// Message panier « livraison standard + différée » (snippets/cart-drawer.liquid).
// Un article différé dont la fenêtre est atteinte (veille) compte comme standard.
class MixedShippingMessage extends HTMLElement {
  connectedCallback() {
    const starts = (this.dataset.differeStarts || '').split(',').filter(Boolean).map(Number);
    const actifs = starts.filter((start) => !ShippingDate.isDiffereExpired(start)).length;
    const standards = (parseInt(this.dataset.standardCount, 10) || 0) + starts.length - actifs;
    this.hidden = !(actifs > 0 && standards > 0);
  }
}

customElements.define('mixed-shipping-message', MixedShippingMessage);

// Mini-carrousel de réassurance (snippets/reassurance-slider.liquid)
// Défilement automatique, points cliquables, pause au survol / focus,
// pas d'autoplay si l'utilisateur préfère réduire les animations.
class ReassuranceSlider extends HTMLElement {
  static INTERVAL_MS = 4000;

  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.reassurance_slider__slide'));
    this.dots = Array.from(this.querySelectorAll('.reassurance_slider__dot'));
    this.index = 0;
    this.timer = null;

    if (this.slides.length < 2) return;

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(parseInt(dot.dataset.index, 10));
        this.restart();
      });
    });

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());

    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  goTo(index) {
    this.index = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((s, i) => s.classList.toggle('is-active', i === this.index));
    this.dots.forEach((d, i) => {
      d.classList.toggle('is-active', i === this.index);
      if (i === this.index) d.setAttribute('aria-current', 'true');
      else d.removeAttribute('aria-current');
    });
  }

  start() {
    if (this.timer || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.timer = setInterval(() => this.goTo(this.index + 1), ReassuranceSlider.INTERVAL_MS);
  }

  stop() {
    clearInterval(this.timer);
    this.timer = null;
  }

  restart() {
    this.stop();
    this.start();
  }
}

customElements.define('reassurance-slider', ReassuranceSlider);


class ProductCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initColorsSwitch();
    this.initSwipers();
  }

  initSwipers() {
    var $target = $(".mySwiper").not(".swiper-initialized").not(".no-swiper");

    if ($target.length) {
      // Pour chaque élément .mySwiper non initialisé, on l'initialise via un each
      $target.each(function () {
        var $swiperContainer = $(this);

        var swiperInstance = new Swiper($(this).get(0), {
          loop: true,
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },
          navigation: {
            nextEl: $(this).closest('product-card').find(".swiper-button-next").get(0),
            prevEl: $(this).closest('product-card').find(".swiper-button-prev").get(0),
          },
          pagination: {
            el: $(this).closest('product-card').find(".swiper-pagination").get(0),
            clickable: true,
          },
          breakpoints: {
            0: {
              allowTouchMove: true,
            },
            789: {
              allowTouchMove: true,
            },
          }
        });

        var $productCard = $(this).closest('product-card');
        $productCard.on('mouseenter', function () {
          swiperInstance.slideToLoop(1);
        });
        $productCard.on('mouseleave', function () {
          swiperInstance.slideToLoop(0);
        });

      });
    }
  }

  initColorsSwitch() {

    // Supprimer tous les gestionnaires d'événements click précédents sur les éléments .color_varian
    $('.card__content .color_variant').off('click');

    $('.card__content .color_variant').click(function (e) {
      e.preventDefault(); // Annuler le comportement par défaut du lien

      var href = $(this).attr('href');
      var new_href = href.split('?')[0];

      var $clicked = $(this);
      var url = new_href + '?section_id=card-product-ajax';

      $.ajax({
        url: url,
        type: 'GET',
        timeout: 2000, // Timeout après 2 secondes
        success: function (data) {
          // Ancienne card dans la grille
          var $old_card = $clicked.closest('.product-card-wrapper');

          // On parse la réponse
          var $data = $(data);

          // On récupère la nouvelle .product-card-wrapper
          var $new_card = $data.filter('.product-card-wrapper').add($data.find('.product-card-wrapper')).first();

          if ($new_card.length) {
            $old_card.replaceWith($new_card);
          } else {
            $old_card.replaceWith(data);
          }

        },
        error: function () {
          console.log('Erreur de la récupération du produit alternatif');
        }
      });
    });
  }
}

customElements.define("product-card", ProductCard);


class QuickAddForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cart = document.querySelector("cart-drawer");
    this.submitButton = this.querySelector("[type='submit']");

    if (this.cart) this.submitButton.setAttribute("aria-haspopup", "dialog");
    this.hideErrors = this.dataset.hideErrors === "true";
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute("aria-disabled") === "true") return;

    this.handleErrorMessage();

    this.submitButton.setAttribute("aria-disabled", true);
    this.submitButton.classList.add("loading");
    // this.querySelector(".loading__spinner").classList.remove("hidden");

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    const formData = new FormData(this.form);
    if (this.cart) {
      formData.append(
        "sections",
        this.cart.sections_to_render().map((section) => section.section)
      );
      formData.append("sections_url", window.location.pathname);
      // this.cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        // En cas d'erreur
        if (response.status) {
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
          if (!soldOutMessage) return;
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButtonText.classList.add("hidden");
          soldOutMessage.classList.remove("hidden");
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }
        this.error = false;
        this.cart.render_contents(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton.classList.remove("loading");
        if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
        if (!this.error) this.submitButton.removeAttribute("aria-disabled");
        //this.querySelector(".loading__spinner").classList.add("hidden");
      });
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product_form_error_wrapper");
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product_form_error_message");

    this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
}

customElements.define("quick-add-form", QuickAddForm);

// Référentiel de pointures (eu / uk / us / it)
// - Résout le référentiel à afficher : choix manuel du client, sinon défaut du marché
//   (window.ELX_SIZE, rendu par snippets/size-system-config.liquid).
// - Convertit tous les libellés [data-eu-key] de la page (fiche produit, quick add des cartes,
//   modale quick add), y compris ceux insérés dynamiquement (ajax, changement de variante).
// - Gère les switchers [data-size-switcher] partout où ils apparaissent.
window.ElxSizeSystem = (function () {
  const ALLOWED = ['eu', 'uk', 'us', 'it'];
  let current = null;

  function config() {
    return window.ELX_SIZE || { marketDefault: 'eu', maps: {} };
  }

  function marketDefault() {
    const d = config().marketDefault;
    return ALLOWED.includes(d) ? d : 'eu';
  }

  // Détermine le référentiel initial et met le localStorage à jour.
  // Le choix manuel n'est réinitialisé que si le référentiel par défaut du marché a changé.
  function resolve() {
    const def = marketDefault();
    let system = def;

    try {
      const savedSystem = localStorage.getItem('sizeSystem');
      const savedDefault = localStorage.getItem('sizeSystemDefault');
      const userSet = localStorage.getItem('sizeSystemUserSet') === '1';
      const defaultChanged = savedDefault && savedDefault !== def;

      if (defaultChanged) {
        // Le marché impose une autre grille => on repasse en auto
        localStorage.setItem('sizeSystem', def);
        localStorage.setItem('sizeSystemDefault', def);
        localStorage.removeItem('sizeSystemUserSet');
      } else if (savedSystem && userSet && ALLOWED.includes(savedSystem)) {
        // Même grille par défaut + choix client => on respecte
        system = savedSystem;
      } else {
        // Première visite ou pas de choix manuel => auto (et on persiste)
        localStorage.setItem('sizeSystem', def);
        localStorage.setItem('sizeSystemDefault', def);
      }
      localStorage.removeItem('sizeSystemCountry'); // ancienne clé, plus utilisée
    } catch (e) {
      system = def;
    }

    return system;
  }

  function convertNode(node, system) {
    const euKey = node.dataset.euKey;
    if (!euKey) return;

    const genre = node.dataset.sizeGenre || node.closest('[data-size-genre]')?.dataset.sizeGenre || 'femme';
    const maps = config().maps || {};
    const map = maps[genre] || maps.femme;
    const row = map && map[euKey];
    if (!row) return; // pas de correspondance => on ne touche pas au libellé

    const value = row[system] || row.eu;

    // Mode suffixe (panier) : on garde la pointure EU affichée et on complète " / 3.5" hors EU
    if (node.hasAttribute('data-size-suffix')) {
      const suffix = system !== 'eu' && value ? ` / ${value}` : '';
      if (node.textContent !== suffix) node.textContent = suffix;
      return;
    }

    if (value && node.textContent !== value) node.textContent = value;
  }

  function markSwitcher(switcher, system) {
    switcher.querySelectorAll('[data-system]').forEach((b) => {
      b.classList.toggle('selected', b.dataset.system === system);
    });
  }

  // Applique le référentiel courant à un sous-arbre (document par défaut)
  function apply(root) {
    if (!current) return;
    root = root || document;

    if (root.nodeType === 1) {
      if (root.matches('[data-eu-key]')) convertNode(root, current);
      if (root.matches('[data-size-switcher]')) markSwitcher(root, current);
    }
    root.querySelectorAll('[data-eu-key]').forEach((n) => convertNode(n, current));
    root.querySelectorAll('[data-size-switcher]').forEach((s) => markSwitcher(s, current));
  }

  function set(system, persist = true) {
    if (!ALLOWED.includes(system)) return;
    current = system;
    apply(document);

    if (persist) {
      try {
        localStorage.setItem('sizeSystem', system);
        localStorage.setItem('sizeSystemUserSet', '1');
        localStorage.setItem('sizeSystemDefault', marketDefault());
      } catch (e) { }
    }

    document.dispatchEvent(new CustomEvent('elx:size-system-change', { detail: { system } }));
  }

  function init() {
    current = resolve();
    apply(document);

    // Clic sur un onglet du switcher = choix manuel du client
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-size-switcher] [data-system]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      set(btn.dataset.system, true);
    });

    // Contenu inséré dynamiquement (changement de variante, ajax, quick add, recherche...)
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((n) => {
          if (n.nodeType === 1) apply(n);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  return { get: () => current, set, apply };
})();

function isInViewport(el) {
  if (typeof el.get(0) === 'undefined') {
    return false;
  }

  const rect = el.get(0).getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= ($(window).height() || $(document).height()) &&
    rect.right <= ($(window).width() || $(document).width())
  );
}